import { addMonths } from "date-fns/addMonths";
import { CommonCalendarOptions, DateRange } from "../../types";
import { CalendarFilters } from "../../filters";
import { CompactMonthView } from "../CompactMonthView";
import { endOfMonth } from "date-fns/endOfMonth";

export interface CalendarYearViewProps extends DateRange, CommonCalendarOptions {
  getOnHeaderClick: (date: Date) => (() => void) | { to: string; replace?: boolean };
  getOnDateClick: (date: Date) => (() => void) | { to: string; replace?: boolean };
  filters?: CalendarFilters;
  currentUserId?: string;
}

export const CalendarYearView = ({
  startDate,
  getOnHeaderClick,
  getOnDateClick,
  filters,
  currentUserId,
}: CalendarYearViewProps) => {
  return (
    <section data-testid="calendar-view-year" className="@container p-4 flex-grow overflow-y-auto">
      <div className="grid grid-cols-1 @2xl:grid-cols-2 @5xl:grid-cols-3 @7xl:grid-cols-4 gap-4">
        {Array.from({ length: 12 }, (_, i) => addMonths(startDate, i)).map((month) => (
          <CompactMonthView
            key={month.getMonth() + "-compact-month-" + month.getFullYear()}
            startDate={month}
            endDate={endOfMonth(month)}
            getOnDateClick={getOnDateClick}
            onHeaderClick={getOnHeaderClick(month)}
            filters={filters}
            currentUserId={currentUserId}
          />
        ))}
      </div>
    </section>
  );
};
